import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function MarketingValidator(marketingSource: string, marketingSourceOther: string): ValidatorFn {
    return (formGroup: AbstractControl): ValidationErrors | null => {
        const group = formGroup as any; 
        const control = group.controls[marketingSource];
        const matchingControl = group.controls[marketingSourceOther];

        if (!control || !matchingControl) {
            return null; 
        }

        if (control.value !== 'Inne') {
            matchingControl.setErrors(null);
            return null;
        }

        if (control.value === 'Inne' && !matchingControl.value) {
            matchingControl.setErrors({ marketingValidator: true });
            return { marketingValidator: true };
        }

        matchingControl.setErrors(null);
        return null;
    };
}
